import { createReducer } from '@reduxjs/toolkit';
import set from 'lodash/set';

import { toggleCommercialIncentiveModal } from '../actions';

export default createReducer(
  {
    isCommercialIncentiveModalVisible: false,
  },
  /* eslint-disable no-param-reassign */
  {
    [toggleCommercialIncentiveModal]: (
      state,
      { payload: { isCommercialIncentiveModalVisible } },
    ) => {
      set(
        state,
        'isCommercialIncentiveModalVisible',
        isCommercialIncentiveModalVisible,
      );
    },
  },
  /* eslint-enable no-param-reassign */
);
